<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;">
          <div class="actionBarStyle">
            <el-input v-model="question" placeholder="问题标题"></el-input>
          </div>
          <div class="actionBarStyle">
            <div><el-input v-model="showOrder" placeholder="顺序"></el-input></div>
          </div>
        </div>
        <div style="padding: 10px;">
          <div id="div1">
          </div>
        </div>
        <div style="padding: 10px;">
          <el-button size="small" type="primary" @click="save">保存</el-button>
          <el-button size="small" type="primary" @click="historyBack">返回</el-button>
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import E from 'wangeditor'
  // const editor = new E('#div1')

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        question: '',
        answer: '',
        helpID: '',
        showOrder: '',
        editor: new E('#div1')
      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.helpID = this.$route.params.id
      this.loadData(this.helpID)
    },
    mounted() {
      this.editor.create()
    },
    methods: {
      loadData(id) {
        let that = this

        var requestUrl = '/score/web/_help_detail.jsp'
        this.axios.get(requestUrl, {
            params: {
              id: that.helpID
            }
          }).then(function(response) {
            that.question = response.data.question
            that.answer = response.data.answer
            that.showOrder = response.data.order_num
            that.editor.txt.html(that.answer)
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      save() {
        let that = this

        this.answer = this.editor.txt.html()

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_help_add_save.jsp'
        this.axios.get(requestUrl, {
            params: {
              question: that.question,
              answer: that.answer,
              order_num: that.showOrder,
              id: that.helpID
            }
          }).then(function(response) {
            load.close()

            that.$router.push('/help_list')
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      historyBack() {
        this.$router.go(-1)
      }
    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;
  }

  .rowStyle {
    display: flex;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }
</style>



// WEBPACK FOOTER //
// src/components/help_add.vue